import React, {useState} from 'react';
import FieldVoting from "../../voting";
import {ALL_REACTIONS} from "../../../../../model2/reaction/const";
import EmojiSymbolDeprecated from "../../../../../gd-components/icons/common/emoji/emoji-symbol";

type Props = {
    className?  : string
    field       : FieldVoting
    onClick     : callback      // open dropdown
    children    : any
}

export default function FieldVoting_InlineValueEmpty(props:Props) {

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    if (isHovered) {
        return (
            <React.Fragment>
                <div className={Classes("ui5-field-editable is-hovered size-default", props.className)}
                     onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                    <div className="flex-row-left-center">
                        <div className="ui5-emoji ui5-black-and-white m-r-8">
                            {/*{ALL_REACTIONS[props.field.voteIcon]}*/}
                            <EmojiSymbolDeprecated symbol={ALL_REACTIONS[props.field.voteIcon]} size="14" />
                        </div>

                        <div className="ui5-txt-no-accent-small">0</div>
                    </div>

                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-editable size-default", props.className)}
                 onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

            </div>
            {props.children}
        </React.Fragment>
    )

}
